import { Layout } from 'components/layout'
import { Container } from 'components/container'
import { Title } from './styled'

export const Share = () => (
  <Layout>
    <Container>
      <Title>Жобаны бөлісу</Title>
    </Container>
  </Layout>
)
